<template>
    <page showDokboxFab showBackButton>
        <h1>DokBox</h1>
        <ion-grid>
            <ion-row>
                <ion-col size="6">
                    <ion-button
                        class="c-ansicht__button"
                        fill="clear"
                        color="dark"
                        @click="ansicht = 'cluster'"
                    >
                        <span
                            class="icon-clusteransicht u-size-large"
                            :class="{ ['-is-active']: ansicht == 'cluster' }"
                        ></span>
                    </ion-button>
                    <!-- <ion-button
                        class="c-ansicht__button"
                        fill="clear"
                        color="dark"
                        @click="ansicht = 'timeline'"
                    >
                        <span
                            class="icon-uhr u-size-large"
                            :class="{ ['-is-active']: ansicht == 'timeline' }"
                        ></span>
                    </ion-button> -->
                    <ion-button
                        class="c-ansicht__button"
                        fill="clear"
                        color="dark"
                        @click="ansicht = 'gallery'"
                    >
                        <span
                            class="icon-bild u-size-large"
                            :class="{ ['-is-active']: ansicht == 'gallery' }"
                        ></span>
                    </ion-button>
                </ion-col>
                <ion-col size="3">
                    <ion-item>
                        <ion-badge v-if="limitYears.length">{{
                            limitYears.length
                        }}</ion-badge>
                        <ion-label>Jahr</ion-label>
                        <ion-select
                            class="c-filter-select"
                            selected-text=" "
                            :multiple="true"
                            @ionChange="limitYears = [...$event.detail.value]"
                            :value="preselectedYear"
                            cancel-text="Abbrechen"
                        >
                            <ion-select-option
                                v-for="(value, key) in this.$store.getters[
                                    'dokbox/timeline'
                                ]"
                                :key="key"
                                :value="value"
                                >{{ value }}</ion-select-option
                            >
                        </ion-select>
                    </ion-item>
                </ion-col>
                <ion-col size="3">
                    <ion-item>
                        <ion-badge v-if="limitCategories.length">{{
                            limitCategories.length
                        }}</ion-badge>
                        <ion-label>
                            Ordner
                        </ion-label>
                        <ion-select
                            class="c-filter-select"
                            selected-text=" "
                            multiple="true"
                            @ionChange="
                                limitCategories = [...$event.detail.value]
                            "
                            :value="preselectedCategory"
                            cancel-text="Abbrechen"
                        >
                            <ion-select-option
                                v-for="(value, key) in this.$store.getters[
                                    'dokbox/categories'
                                ]"
                                :key="key"
                                :value="value.id"
                                >{{ value.name }}</ion-select-option
                            >
                        </ion-select>
                    </ion-item>
                </ion-col>
            </ion-row>

            <dokbox-card
                v-show="ansicht == 'cluster'"
                :token="token"
                :limitCategories="limitCategories"
                :limitYears="limitYears"
                @is-empty="isDokboxCardEmpty = $event"
            >
            </dokbox-card>

            <!-- <ion-row v-show="ansicht == 'timeline'">
                <ion-col v-if="$store.getters['dokbox/fileGroups'].length > 0">
                    <div class="c-bautagebuch">
                        <bautagebuch-card
                            v-for="(fileGroup, index) in $store.getters[
                                'dokbox/fileGroups'
                            ]"
                            :key="fileGroup.files[0].fileId"
                            :title="fileGroup.name"
                            :description="fileGroup.description"
                            :fileCount="fileGroup.files.length"
                            :folder="getCategoryName(fileGroup.categoryId)"
                            :imageUrl="
                                fileGroup.files[0].fileThumbnailUrl +
                                    '&TokenId=' +
                                    token
                            "
                            :fileType="fileGroup.files[0].fileType"
                            :fileGroupIndex="index"
                            :date="fileGroup.date"
                            :index="index"
                        ></bautagebuch-card>
                    </div>
                </ion-col>
            </ion-row> -->

            <dokbox-image
                v-show="ansicht == 'gallery'"
                :token="token"
            ></dokbox-image>

            <ion-row
                v-if="
                    $store.getters['dokbox/fileGroups'].length === 0 &&
                    $store.state.loading
                "
            >
                <ion-col size="12" size-md="6" v-for="index in 5" :key="index">
                    <dokbox-card :token="token"> </dokbox-card>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div
            class="ion-margin-top"
            v-if="
                $store.state.dokbox.files.length === 0 &&
                !$store.state.loading &&
                !(ansicht === 'cluster' && !isDokboxCardEmpty)
            "
        >
            Keine Dateien vorhanden. Bitte überprüfe deine Filter oder füge eine
            neue Datei hinzu.
        </div>
        <ion-infinite-scroll
            @ionInfinite="loadMore"
            threshold="100px"
            position="bottom"
            :disabled="isInfiniteScrollDisabled"
        >
            <ion-infinite-scroll-content></ion-infinite-scroll-content>
        </ion-infinite-scroll>
    </page>
</template>

<script>
import Page from "@/components/Page";
import DokboxCard from "@/components/DokboxCard";
// import BautagebuchCard from "@/components/BautagebuchCard";
import DokboxImage from "@/components/DokboxImage";
import { BASEURL } from "@/utils/globals";
import { getTokenId } from "@/api/auth";

export default {
    components: {
        Page,
        DokboxCard,
        DokboxImage,
    },
    data() {
        return {
            limitStart: 0,
            limit: 15,
            // limitPrivate,
            // limitPublic,
            preselectedYear: "",
            limitYears: [],
            preselectedCategory: "",
            limitCategories: [],
            // limitSearch
            ansicht: "cluster",
            baseurl: BASEURL,
            token: "",
            isInfiniteScrollDisabled: false,
            isDokboxCardEmpty: false,
        };
    },
    mounted() {
        this.$ionic.alertController
            .create({
                header: "Dokbox Upload nicht möglich",
                message:
                    "Ein neuer Upload ist leider nicht mehr möglich. Du kannst alle bereits hochgeladenen Dokumente anschauen und bis zum 17.04.2023 sichern. Danach sind sie nicht mehr abrufbar.",
                buttons: ["Verstanden"],
            })
            .then((a) => {
                a.present();
            });
        if ("ansicht" in this.$route.query) {
            this.ansicht = this.$route.query.ansicht;
        }
        if ("jahr" in this.$route.query) {
            this.preselectedYear = this.$route.query.jahr;
            this.limitYears = [this.$route.query.jahr];
        }
        getTokenId().then((response) => {
            if (response.data.Status === 200) {
                this.token = response.data.Result.TokenId;
                this.$store.commit(
                    "setGalleryToken",
                    response.data.Result.TokenId
                );
            }
        });
        this.$store.dispatch("dokbox/getDokbox").then(() => {
            if ("ordner" in this.$route.query) {
                let categories = this.$store.state.dokbox.details.categories;
                for (let key in categories) {
                    if (categories[key].name === this.$route.query.ordner) {
                        this.preselectedCategory = categories[key].id;
                        this.limitCategories = [categories[key].id];
                        break;
                    }
                }
            }
            this.$store.dispatch("dokbox/getDokboxFiles", this.getFilterData());
        });
    },
    watch: {
        limitYears() {
            this.limitStart = 0;
            this.$store.dispatch("dokbox/getDokboxFiles", this.getFilterData());
        },
        limitCategories() {
            this.limitStart = 0;
            this.$store.dispatch("dokbox/getDokboxFiles", this.getFilterData());
        },
        reset(value) {
            if (value) {
                this.limitStart = 0;
                this.$store.dispatch(
                    "dokbox/getDokboxFiles",
                    this.getFilterData()
                );
                this.$store.commit("dokbox/setReset", false);
            }
        },
        limitStart(value) {
            if (value === 0) {
                this.isInfiniteScrollDisabled = false;
            }
        },
    },
    methods: {
        getFilterData() {
            return {
                limitStart: this.limitStart,
                limit: this.limit,
                limitYears: this.limitYears,
                limitCategories: this.limitCategories,
                ansicht: this.ansicht,
            };
        },

        loadMore(event) {
            this.limitStart = this.limitStart + this.limit;
            this.$store
                .dispatch("dokbox/getDokboxFiles", this.getFilterData())
                .then((response) => {
                    if (response.data.Result.files.length === 0) {
                        this.isInfiniteScrollDisabled = true;
                        this.$ionic.toastController
                            .create({
                                color: "dark",
                                duration: 2000,
                                message: "Alle Dateien geladen",
                                showCloseButton: true,
                                closeButtonText: "Schließen",
                            })
                            .then((toast) => {
                                toast.present();
                            });
                    }
                })
                .finally(() => {
                    event.target.complete();
                });
        },
    },

    computed: {
        reset() {
            return this.$store.state.dokbox.reset;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-dokbox-cards {
    position: relative;

    &:before {
        content: "";
        display: block;
        height: 100%;
        position: absolute;
        left: 20px;
        border-left: dashed 4px var(--ion-color-medium);
        margin-top: 10px;
    }
}

.c-ansicht {
    &__button {
        .-is-active {
            color: var(--ion-color-primary);
        }
        // &:first-child {
        //   margin-left: 0;
        //   --padding-start: 0;
        // }
    }
}

// body /deep/ .select-text{
//   background: blue;
// }

.c-filter-select {
    width: 0;
    padding: 0;

    &:after {
        content: "";
        display: block;
        // width: 21px;
        // height: 21px;
        position: absolute;
        // right: 0;

        right: 5px;
        top: 50%;
        margin-top: -3px;
        width: 0;
        height: 0;
        border-top: 5px solid;
        border-right: 5px solid transparent;
        border-left: 5px solid transparent;
        color: currentColor;
        opacity: 0.33;
        pointer-events: none;
    }
}

ion-badge {
    position: absolute;
    font-size: 8px;
    padding: 2px 4px;
    top: 50%;
    right: 4px;
    left: unset;
    transform: translate(0, -50%);
    z-index: 3;
}
</style>
